// client/src/api/ApiPartnerInvite.js
import flex from './FlexFetch'

async function getPartnerInvite(token) {
  const response = await flex.flexFetch(
    `/api/1.0/registrations/partnerInvite?token=${encodeURIComponent(token)}`,
  )
  return await flex.handleResponse(response)
}

async function confirmPartner(token) {
  const response = await flex.flexFetch(
    '/api/1.0/registrations/confirmPartner',
    {
      method: 'POST',
      body: JSON.stringify({ token }),
    },
  )
  return await flex.handleResponse(response)
}

async function declinePartner(token) {
  const response = await flex.flexFetch(
    '/api/1.0/registrations/declinePartner',
    {
      method: 'POST',
      body: JSON.stringify({ token }),
    },
  )
  return await flex.handleResponse(response)
}

const ApiPartnerInvite = {
  getPartnerInvite,
  confirmPartner,
  declinePartner,
}

export default ApiPartnerInvite
